import { render, staticRenderFns } from "./Cabinets.vue?vue&type=template&id=8658e45a&scoped=true"
import script from "./Cabinets.vue?vue&type=script&lang=js"
export * from "./Cabinets.vue?vue&type=script&lang=js"
import style0 from "./Cabinets.vue?vue&type=style&index=0&id=8658e45a&prod&scoped=true&lang=less"
import style1 from "./Cabinets.vue?vue&type=style&index=1&id=8658e45a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8658e45a",
  null
  
)

export default component.exports